import React, { useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import BackgroundAnimation from './components/BackgroundAnimation';
import Ticker from './components/Ticker';
import Splash from './components/Splash';

function App() {
    const [showSplash, setShowSplash] = useState(true);

    const handleEnter = () => {
        setShowSplash(false);
    };

    return (
        <div className="min-h-screen bg-black text-white selection:bg-green-500/30 overflow-x-hidden relative">
            {showSplash && <Splash onEnter={handleEnter} />}
            <BackgroundAnimation />
            <Ticker />
            <div className={`pt-10 transition-opacity duration-1000 ${showSplash ? 'opacity-10' : 'opacity-100'}`}>
                <Header />
                <main className="relative z-10">
                    <Hero />
                </main>
            </div>
        </div>
    );
}

export default App;
